import { render, staticRenderFns } from "./ShopMenuSortBy.vue?vue&type=template&id=c79982d6&scoped=true&"
import script from "./ShopMenuSortBy.vue?vue&type=script&lang=js&"
export * from "./ShopMenuSortBy.vue?vue&type=script&lang=js&"
import style0 from "./ShopMenuSortBy.vue?vue&type=style&index=0&id=c79982d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79982d6",
  null
  
)

export default component.exports